import requestFunctions from "../../functions/requestFunctions";


export const state = {
  ACCOUNTS_ITEM: {},
  ACCOUNTS_LIST: [],
  ACCOUNTS_TABLE_DATA: [],
  ACCOUNTS_LIST_DATA: [],
  ACCOUNT_TARIFF: [],
  ACCOUNTS_TOTAL_ROWS: 0
}

export const getters = {
  GET_ACCOUNT_TARIFF: (state) => {
    return state.ACCOUNT_TARIFF;
  },
  GET_ACCOUNTS_ITEM: (state) => {
    return state.ACCOUNTS_ITEM;
  },
  GET_ACCOUNTS_LIST: (state) => {
    return state.ACCOUNTS_LIST;
  },
  GET_ACCOUNTS_TABLE_DATA: (state) => {
    return state.ACCOUNTS_TABLE_DATA;
  },
  GET_ACCOUNTS_LIST_DATA: (state) => {
    return state.ACCOUNTS_LIST_DATA;
  },
  GET_ACCOUNTS_TOTAL_ROWS: (state) => {
    return state.ACCOUNTS_TOTAL_ROWS;
  }
}

export const mutations = {
  UPDATE_ACCOUNT_TARIFF(state, item) {
    state.ACCOUNT_TARIFF = item;
  },
  UPDATE_ACCOUNTS_ITEM(state, item) {
    state.ACCOUNTS_ITEM = item;
  },
  UPDATE_ACCOUNTS_LIST(state, list) {

    state.ACCOUNTS_LIST = list.data;
    state.ACCOUNTS_TABLE_DATA = [];
    state.ACCOUNTS_LIST_DATA = [];

    state.ACCOUNTS_TOTAL_ROWS = list.total;
    list = list.data;


    list.forEach(el => {

      let fullname = '';

      if (el.profile_name3) { fullname = fullname + el.profile_name3 + ' '; }
      if (el.profile_name1) { fullname = fullname + el.profile_name1 + ' '; }
      if (el.profile_name2) { fullname = fullname + el.profile_name2 + ' '; }

      let status;
      if(el.status === 'active'){
        status = 'Активный'
      }
      if(el.status === 'wait'){
        status = 'Ожидает активации'
      }
      if(el.status === 'blocked'){
        status = 'Заблокирован'
      }
      if(el.status === 'disabled'){
        status = 'Отключен'
      }

      let balance = el.balance ? el.balance + ' руб.' : '0 руб.';

      let phone    = el.user_phone ? el.user_phone : '';
      let company  = el.company_name ? el.company_name : '';

      let payment_type = '';

      if(el.payment_type === 'before'){
        payment_type = 'Предоплатный';
      }
      if(el.payment_type === 'after'){
        payment_type = 'Постоплатный';
      }

      let credit = el.credit ? el.credit + ' руб.' : '0 руб.';

      let user_data = "";

      if(fullname !== ''){
        user_data = fullname;
      }
      if(el.user_phone){
        if(user_data !== ''){
          user_data = user_data + ', ';
        }
        user_data = user_data + el.user_phone;
      }
      if(el.user_email){
        if(user_data !== ''){
          user_data = user_data + ', ';
        }
        user_data = user_data + el.user_email;
      }


      state.ACCOUNTS_TABLE_DATA.push({
        'number': el.number,
        'tariff_name' : el.tariff_name ? el.tariff_name : null,      
        'user_data'   : user_data,
        'company_name' : company,
        'balance' : balance,
        'status'  : status,
        'payment_type' : payment_type,
        'credit' : credit,
        'blocked_at' : el.blocked_at,
        'activated_at' : el.activated_at,
        'uuid' : el.uuid,
        'id' : el.id
      });

      let acc_name = el.number;

      if (acc_name !== '') {
        acc_name = acc_name + ', ';
      }
      acc_name = acc_name + phone;

      if (fullname !== '') {
        if (acc_name !== '') {
          acc_name = acc_name + ' - ';
        }
        acc_name = acc_name + fullname;
      }

      acc_name = acc_name + ', ' + balance;

      state.ACCOUNTS_LIST_DATA.push({
        'id': el.id,
        'name': acc_name,
        'user_id': el.user_id,
        'company_id': el.company_id,
      });
    });

  },
}

export const actions = {

  async FETCH_ACCOUNTS_ITEM({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/accounts/'+payload.uuid;
    
    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_ACCOUNTS_ITEM', response.data);
      return response.data;
    }

  },

  async FETCH_ACCOUNT_TARIFF({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/accounts/'+payload.uuid+'/tariff';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_ACCOUNT_TARIFF', response.data);
      return response.data;
    }
  },

  async FETCH_ACCOUNTS_LIST({ commit }, payload = {}) {

    let query_url = 'https://api.client.za-bota.com/v1/accounts';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_ACCOUNTS_LIST', response.data);
      return response.data;
    }

  },

  async FETCH_ACCOUNTS_CREATE({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/accounts';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'POST');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

  async FETCH_ACCOUNTS_UPDATE({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/accounts/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'PUT');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

  async FETCH_ACCOUNTS_DELETE({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/accounts/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'DELETE');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

}